import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getRatingOptions, getRatingValue } from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import MultiSelectDropdown from '../MultiSelectComponent/MultiSelectPrimary/selectDropDownComponent';
import { SingleOption } from '../licenseAnalyticsSupport/typeInterfaces';
import { useTranslation } from 'react-i18next';
import { setRatingValue } from '../../../redux/reducers/licenceAnalytics';

const RatingFilterComponent: React.FC = () => {
  const options: SingleOption[] = useSelector(getRatingOptions);
  const value: SingleOption | SingleOption[] | undefined = useSelector(getRatingValue);
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const onChange = (newValue: SingleOption | SingleOption[] | undefined): void => {
    dispatch(setRatingValue({ newValue }));
  };

  return (
    <MultiSelectDropdown
      title={t("RATING")}
      options={options}
      value={value}
      onChange={onChange}
      isMulti={true}
      width="100%"
      rootCss={{ width: '100%' }}
    />
  );
};

export default RatingFilterComponent;
